import { render, staticRenderFns } from "./SubscriptionForm.Purchase.InovioPayIframe.vue?vue&type=template&id=629e4005&scoped=true&"
import script from "./SubscriptionForm.Purchase.InovioPayIframe.vue?vue&type=script&lang=js&"
export * from "./SubscriptionForm.Purchase.InovioPayIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629e4005",
  null
  
)

export default component.exports